import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSlack = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 127 127",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M27.2 80c0 7.3-5.9 13.2-13.2 13.2C6.7 93.2.8 87.3.8 80c0-7.3 5.9-13.2 13.2-13.2h13.2V80z",
			fill: "#E01E5A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.8 80c0-7.3 5.9-13.2 13.2-13.2 7.3 0 13.2 5.9 13.2 13.2v33c0 7.3-5.9 13.2-13.2 13.2-7.3 0-13.2-5.9-13.2-13.2V80z",
			fill: "#E01E5A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47 27.2c-7.3 0-13.2-5.9-13.2-13.2C33.8 6.7 39.7.8 47 .8c7.3 0 13.2 5.9 13.2 13.2v13.2H47z",
			fill: "#36C5F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47 33.8c7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2H14C6.7 60.2.8 54.3.8 47c0-7.3 5.9-13.2 13.2-13.2h33z",
			fill: "#36C5F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M99.8 47c0-7.3 5.9-13.2 13.2-13.2 7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2H99.8V47z",
			fill: "#2EB67D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.2 47c0 7.3-5.9 13.2-13.2 13.2-7.3 0-13.2-5.9-13.2-13.2V14C66.8 6.7 72.7.8 80 .8c7.3 0 13.2 5.9 13.2 13.2v33z",
			fill: "#2EB67D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80 99.8c7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2-7.3 0-13.2-5.9-13.2-13.2V99.8H80z",
			fill: "#ECB22E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80 93.2c-7.3 0-13.2-5.9-13.2-13.2 0-7.3 5.9-13.2 13.2-13.2h33c7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2H80z",
			fill: "#ECB22E"
		})
	]
});
export default SvgIconSlack;
